import { useEffect, useState } from "react";
import { axiosGet } from "./api";

const DEFAULT_ADMIN_WHATSAPP_NUMBER = "966554482522";
const DEFAULT_WEBSITE_PHONE_NUMBER = "920022631";
const ADMIN_WHATSAPP_ENDPOINT =
  "/api/method/alltimes.www.api.get_admin_whatsapp_number";

let cachedAdminContactNumbers = null;
let adminContactRequest = null;

const sanitizeNumber = (value) => String(value || "").replace(/\D/g, "");

const normalizeWhatsAppNumber = (value) =>
  sanitizeNumber(value) || DEFAULT_ADMIN_WHATSAPP_NUMBER;

const normalizeWebsitePhoneNumber = (value) =>
  sanitizeNumber(value) || DEFAULT_WEBSITE_PHONE_NUMBER;

export const getAdminContactNumbers = async () => {
  if (cachedAdminContactNumbers) {
    return cachedAdminContactNumbers;
  }

  if (!adminContactRequest) {
    adminContactRequest = axiosGet(ADMIN_WHATSAPP_ENDPOINT)
      .then((response) => {
        cachedAdminContactNumbers = {
          whatsappNumber: normalizeWhatsAppNumber(
            response?.result?.whatsapp_number
          ),
          websitePhoneNumber: normalizeWebsitePhoneNumber(
            response?.result?.website_phone_number
          ),
        };
        return cachedAdminContactNumbers;
      })
      .catch((error) => {
        console.error("Error fetching admin contact numbers:", error);
        cachedAdminContactNumbers = {
          whatsappNumber: DEFAULT_ADMIN_WHATSAPP_NUMBER,
          websitePhoneNumber: DEFAULT_WEBSITE_PHONE_NUMBER,
        };
        return cachedAdminContactNumbers;
      })
      .finally(() => {
        adminContactRequest = null;
      });
  }

  return adminContactRequest;
};

export const getAdminWhatsappNumber = async () => {
  const { whatsappNumber } = await getAdminContactNumbers();
  return whatsappNumber;
};

export const getAdminWhatsAppLink = (whatsappNumber) =>
  `https://wa.me/${normalizeWhatsAppNumber(whatsappNumber)}`;

export const useAdminWhatsAppNumber = () => {
  const [contactNumbers, setContactNumbers] = useState(
    cachedAdminContactNumbers || {
      whatsappNumber: DEFAULT_ADMIN_WHATSAPP_NUMBER,
      websitePhoneNumber: DEFAULT_WEBSITE_PHONE_NUMBER,
    }
  );

  useEffect(() => {
    let isMounted = true;

    getAdminContactNumbers().then((numbers) => {
      if (isMounted) {
        setContactNumbers(numbers);
      }
    });

    return () => {
      isMounted = false;
    };
  }, []);

  return {
    whatsappNumber: contactNumbers.whatsappNumber,
    websitePhoneNumber: contactNumbers.websitePhoneNumber,
    whatsappLink: getAdminWhatsAppLink(contactNumbers.whatsappNumber),
  };
};
